import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		subformPerilsDeductibles_perilDeductibles: {

		},
		subformPerilsDeductibles_perilDeductiblesLabel: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h5.fontSize,
		},
	});
});

export default useStyles;
